document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.rotate-wrapp');
  if (!wrapper) return;

  const words = wrapper.querySelectorAll('span');

  let index = 0;
  const total = words.length;

  function rotate() {
    index += 1;

    if (index === total) {
      index = 0;
      wrapper.style.transform = 'translateY(0)';
    } else {
      applyMove();
    }
  }

  function applyMove() {
    wrapper.style.transform = `translateY(-${index * 100}%)`;
  }

  setInterval(rotate, 2500);
});
